export const getBlogs = ({ seniorTodayBlogReducer: { blogs = [] } = {} }) => blogs;
export const getBlogFilter = ({ seniorTodayBlogReducer: { filter = {} } = {} }) => filter;
export const getBlogsCount = ({ seniorTodayBlogReducer: { count = 0 } = {} }) => count;
export const getCommonFilter = ({ seniorTodayBlogReducer: { common_filter = {} } = {} }) => common_filter;
